import objectPath from 'object-path'
import {
  setRowDataToBulkForm,
} from 'designer/component/action/Data'
import {
  onCheckCondition,
  onUpdateCondition,
} from '../../../action/condition/Action'
import {
  updateSelectRowFormData,
  updateTabSelectRow,
} from '../action/SelectRow'

export const createRowSelectionHelper = ({
  props,
  uischema,
  jsonForm,
  formData,
  setFormData,
  columnRefId,
  dataRowClicked,
  setDataRowClicked,
  setFieldFormData,
  designContext,
  isUiChanged,
  setIsUiChanged,
  componentPropsData,
  setComponentPropsData,
  designerPropsData,
  tableData,
}) => {
  const updateOnlySelectToFormData = (rowData) => {
    let { requestDataType, formDataKey, bulkDataKey } = uischema
    if (!requestDataType) return
    if (requestDataType === 'single') {
      if (!formDataKey) return
      let formGroup = jsonForm?.formGroup || []
      let form = formGroup.find(({ key }) => key === formDataKey)
      if (!form) return
      formData = updateSelectRowFormData({
        form,
        formData,
        rowData,
        designContext,
      })
    } else if (requestDataType === 'bulk') {
      if (!bulkDataKey) return
      let bulkGroup = jsonForm?.bulkGroup || []
      let bulkForm = bulkGroup.find(({ key }) => key === bulkDataKey)
      if (!bulkForm) return
      formData = setRowDataToBulkForm(bulkForm, {
        jsonForm,
        formData,
        rowData,
      })
    }
    setFormData(formData)
  }

  const createClickRow = (rowData) => {
    let rowDataId
    let dataRowClickedId
    if (columnRefId) {
      rowDataId = objectPath.get(rowData, columnRefId)
      dataRowClickedId = objectPath.get(dataRowClicked, columnRefId)
    } else {
      rowDataId = rowData && rowData.id
      dataRowClickedId = dataRowClicked && dataRowClicked.id
    }
    let dataRowClicked
    let isSameSelected =
      rowDataId && dataRowClickedId && rowDataId === dataRowClickedId
    if (isSameSelected) {
      dataRowClicked = {}
      setFieldFormData(`@rowSelected.${uischema.key}`, {})
      onCheckCondition(designContext, formData, uischema.key, {
        isSelectRow: false,
        isUnSelectRow: true,
      })
      setIsUiChanged(isUiChanged)
    } else {
      dataRowClicked = rowData
      setFieldFormData(`@rowSelected.${uischema.key}`, rowData)
      onCheckCondition(designContext, formData, uischema.key, {
        isSelectRow: true,
        rowData,
      })
    }
    setDataRowClicked(dataRowClicked)
    objectPath.set(isUiChanged, uischema.key, {
      isRender: true,
      dataRowClicked,
    })
    setIsUiChanged(isUiChanged)
    return isSameSelected
  }

  const checkSelectRowIndex = (key) => {
    let { selectRowIndex = {} } = isUiChanged
    let selectList = Object.keys(selectRowIndex)
    let countIndex = selectList.length
    let hasIndex = objectPath.has(selectRowIndex, key)
    let index = objectPath.get(selectRowIndex, key)
    if (!hasIndex) {
      objectPath.set(selectRowIndex, [key], countIndex)
    }
    let updateSelect = selectList.filter((selectKey) => {
      if (selectKey === key) return
      let selectIndex = selectRowIndex[selectKey]
      return selectIndex > index
    })
    updateSelect.forEach((key) => {
      objectPath.set(componentPropsData, 'data', {})
      objectPath.set(componentPropsData, 'isClosed', false)
      objectPath.set(componentPropsData, 'isSelectedRow', false)
      objectPath.set(componentPropsData, 'rowData', {})
      setComponentPropsData(componentPropsData)
      setFieldFormData(`@rowSelected.${key}`, {})
      onUpdateCondition(props, designContext, key, formData, {
        isSelectRow: false,
        isUnSelectRow: true,
        isDebounce: true,
        delayTime: 0,
        debounceName: `select-table-${key}`,
      })
      objectPath.set(isUiChanged, key, { isRender: true })
    })
    objectPath.set(isUiChanged, uischema.key, { isRender: true })
    objectPath.set(isUiChanged, 'selectRowIndex', selectRowIndex)
    setIsUiChanged(isUiChanged)
  }

  const selectRow = async (rowAction, rowData) => {
    let rowDataId
    let dataRowClickedId
    if (columnRefId) {
      rowDataId = objectPath.get(rowData, columnRefId)
      dataRowClickedId = objectPath.get(dataRowClicked, columnRefId)
    } else {
      rowDataId = rowData && rowData.id
      dataRowClickedId = dataRowClicked && dataRowClicked.id
    }
    let isSameSelected =
      rowDataId && dataRowClickedId && rowDataId === dataRowClickedId
    if (isSameSelected) {
      objectPath.set(componentPropsData, 'data', {})
      objectPath.set(componentPropsData, 'isClosed', false)
      objectPath.set(componentPropsData, 'isSelectedRow', false)
      objectPath.set(componentPropsData, 'rowData', {})
      setComponentPropsData(componentPropsData)
      setDataRowClicked({})
      setFieldFormData(`@rowSelected.${uischema.key}`, {})
      onUpdateCondition(props, designContext, uischema.key, formData, {
        isSelectRow: false,
        isUnSelectRow: true,
        isDebounce: true,
        delayTime: 0,
        debounceName: `select-table-${uischema.key}`,
      })
      objectPath.del(isUiChanged, ['pageTable', uischema.key])
    } else {
      let data = {}
      let sendProps = objectPath.get(designerPropsData, 'send') || []
      let tableProp = sendProps.filter(({ source }) => source === uischema.key)
      if (tableProp.length > 0) {
        tableProp.forEach((prop) => {
          if (prop.propType === 'table') {
            objectPath.set(data, prop.prop, rowData)
          } else if (prop.propType === 'condition') {
            objectPath.set(data, prop.prop, 1)
          } else if (prop.propType === 'custom') {
            objectPath.set(data, prop.prop, prop.value)
          } else if (prop.propType === 'input') {
            objectPath.set(data, prop.prop, objectPath.get(formData, prop.key))
          } else if (prop.propType === 'formData' && formData.props) {
            objectPath.set(data, prop.prop, objectPath.get(formData, prop.prop))
          }
        })
      }
      let componentPropsData = {}
      objectPath.set(componentPropsData, 'data', data)
      if (rowAction.selectType === 'onSelect') {
        updateOnlySelectToFormData(rowData)
        objectPath.set(componentPropsData, 'isClosed', false)
      } else if (rowAction.selectType === 'onTab') {
        await updateTabSelectRow({
          rowAction,
          formData,
          rowData,
          designContext,
        })
        objectPath.set(componentPropsData, 'isClosed', false)
      } else {
        objectPath.set(componentPropsData, 'isClosed', true)
      }
      objectPath.set(componentPropsData, 'isSelectedRow', true)
      objectPath.set(componentPropsData, 'rowData', rowData)
      setComponentPropsData(componentPropsData)
      setDataRowClicked(rowData)
      setFieldFormData(`@rowSelected.${uischema.key}`, rowData)
      onUpdateCondition(props, designContext, uischema.key, formData, {
        isSelectRow: true,
        rowData,
        isDebounce: true,
        delayTime: 0,
        debounceName: `select-table-${uischema.key}`,
      })
      checkSelectRowIndex(uischema.key)
    }
    objectPath.set(isUiChanged, uischema.key, { isRender: true })
    setIsUiChanged(
      rowAction.selectType === 'onTab' ? { ...isUiChanged } : isUiChanged
    )
  }

  const handleRowSelectAll = (checked) => {
    let rowSelection = checked ? tableData : []
    objectPath.set(isUiChanged, ['tableSelection', uischema.key], rowSelection)
    setIsUiChanged(isUiChanged)
  }

  const syncSelectedRow = () => {
    let selectedRow =
      objectPath.get(formData, `@rowSelected.${uischema.key}`) || {}
    setDataRowClicked(selectedRow)
  }

  return {
    updateOnlySelectToFormData,
    createClickRow,
    checkSelectRowIndex,
    selectRow,
    handleRowSelectAll,
    syncSelectedRow,
  }
}
